import React, { useState, useEffect, useRef } from 'react';
import './Home.css';
//import mainBannerImage from '../assets/mainBannerImage.png'; // Add your soccer ball image
import blur1 from '../assets/blur1.png';
import blur2 from '../assets/blur2.png';
import blur3 from '../assets/blur3.png';
import blur4 from '../assets/blur4.png';

import homeBanner1 from '../assets/homeBanner1.png';
import homeBanner2 from '../assets/homeBanner2.png';
import homeBanner3 from '../assets/homeBanner3.png';
import homeBanner4 from '../assets/homeBanner4.png';
import {trackEvent} from "../utils/Analytics";
import { getContent } from '../services/contentService';

const today = new Date();
const month = today.toLocaleString('default', { month: 'long' });
const year = today.getFullYear();

const FETCH_CONTENT_ENABLED = true;

const bluredImages = [
    { src: blur1, text: '', color: '#000',fontColor: '#FFD700' },
    { src: blur2, text: '', color: '#DC1B04' },
    { src: blur3, text: '', color: '#238C2C', fontColor: '#FFD700'  },
    { src: blur4, text: '', color: '#09468E' },
];

const defaultImages = [
    { src: homeBanner1, text: 'Hawk Tooey Challenge is Here!', color: '#000',fontColor: '#FFD700' },
    { src: homeBanner2, text: 'Birthday Scavenger Hunt is Coming Soon!', color: '#DC1B04' },
    { src: homeBanner3, text: 'BitLife\'s Birthday Month', color: '#238C2C', fontColor: '#FFD700'  },
    { src: homeBanner4, text: 'Did You Know?', color: '#09468E' },
];

function Home() {
    const [images, setImages] = useState(bluredImages);
    const [isLoading, setIsLoading] = useState(true);
    const mountTime = useRef(performance.now());
    const effectRan = useRef(false);

    useEffect(() => {
        if (effectRan.current === true) {
            return; // Prevent effect from running twice in development
        }
        const initialRenderTime = performance.now();
        console.log(`Time from mount to show blurred images: ${(initialRenderTime - mountTime.current).toFixed(2)}ms`);
        const fetchContent = async () => {
            const startTime = performance.now();
            try {
                const data = await getContent();

                if (data && Array.isArray(data.slots)) {
                    // Map the fetched slots to the format your component needs
                    const newImages = data.slots.map((slot, index) => ({
                        src: slot.imageUrl,
                        text: slot.description,
                        // Merge with styling from the default array
                        color: defaultImages[index]?.color,
                        fontColor: defaultImages[index]?.fontColor,
                    }));

                    // Filter out any slots that might not have a corresponding style
                    const validImages = newImages.filter(img => img.color);
                    if (newImages.length > 0) {
                        const validImagesReadyTime = performance.now();
                        console.log(`Time from mount to set valid images: ${(validImagesReadyTime - mountTime.current).toFixed(2)}ms`);
                        setImages(validImages);
                        const endTime = performance.now();
                        const duration = Math.round(endTime - startTime);
                        trackEvent('main_images_downloaded', 'MainImagesDownloaded', `Main Images Downloadtime: ${duration}ms`);
                    }
                    else
                    {
                        const endTime = performance.now();
                        const duration = Math.round(endTime - startTime);
                        trackEvent('main_images_downloaded_lenthzero', 'MainImagesDownloadedLengthZero', `Main Images Sownloaded lenght zero Downloadtime: ${duration}ms`);       
                    }

                } else {
                    console.error("API response is not in the expected format:", data);
                    // The component will continue to use defaultImages
                    setImages(defaultImages); // Fallback on fetch error
                }

            } catch (error) {
                console.error("Could not fetch content:", error);
                // Fallback to defaultImages is already handled by the initial state
                setImages(defaultImages); // Fallback on fetch error
            } finally {
                setIsLoading(false);
            }
        };

        if(FETCH_CONTENT_ENABLED){
            setImages(bluredImages);
            fetchContent();
        }
        else
        {
            setImages(defaultImages);
            setIsLoading(false);
            trackEvent('main_images_default', 'MainImagesDefault', 'Default images used, fetch disabled');
        }

        return () => {
            effectRan.current = true;
        };
    }, []); // Empty dependency array ensures this runs only once on mount
    
    return (
        <div className="home-view">
            <div className="main-banner">
                <span className="main-banner-date">{month} {year}</span>
                {/*showMainBannerImage && <img src={mainBannerImage} alt="Main Banner" className="main-banner-img" />*/}
                {/*showMainBannerMessage && <span className="main-banner-msg">It's Soccer Time!</span>*/}
            </div>
            <div className="image-grid">
                {isLoading ? (
                    // Render Skeleton Loaders
                    bluredImages.map((img, idx) => (
                        <div className="grid-item" key={idx}>
                            <img src={img.src} alt={`Grid ${idx + 1}`} className="grid-img" />
                            <div
                                className="grid-text"
                                style={{ backgroundColor: img.color, color: img.fontColor }}
                            >
                                {img.text}
                            </div>
                        </div>
                    ))
                ) : (
                    // Render Actual Content
                    images.map((img, idx) => (
                        <div className="grid-item" key={idx}>
                            <img src={img.src} alt={`Grid ${idx + 1}`} className="grid-img" />
                            <div
                                className="grid-text"
                                style={{ backgroundColor: img.color, color: img.fontColor }}
                            >
                                {img.text}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default Home;
